import logo from "./logo.svg";
import "./App.scss";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Home from "./components/Home/Home";
import ProjectDetail from "./components/ProjectDetail/ProjectDetail";
import Error from "./components/Error/Error";
import { createContext } from "react";
import img1 from "./images/projects/img1.png";
import img2 from "./images/projects/img2.png";
import img3 from "./images/projects/img3.png";
import img4 from "./images/projects/img4.png";
import img5 from "./images/projects/img5.png";
import img6 from "./images/projects/img6.png";
import img7 from "./images/projects/img7.png";
import img8 from "./images/projects/img8.png";
import img9 from "./images/projects/img9.png";

const Context = createContext();
function App() {
  const project_arr = [
    {
      name: "Dictonary App",
      banner: img1,
      img: [img1, img2],
      tech: "REACT JS,Material UI,HTML,CSS,",
      desc: "Dictonary App Using React JS,Materaial UI,API Integration",
      link: "https://dictonary.netlify.app/",
    },
    {
      name: "Quotes App",
      banner: img3,
      img: [img3, img4, img5],
      tech: "HTML,CSS,JavaScript,API",
      desc: "Quotes App Using HTML,CSS,JavaScript",
      link: "https://sahil3554.github.io/Random-Quotes/",
    },
    {
      name: "Weather App",
      banner: img7,
      img: [img6, img7, img8],
      tech: "Express JS,Weather API,HTML,CSS",
      desc: "Weather App Using Express JS,Weather API,HTML,CSS",
      link: "https://express-js-weather.herokuapp.com/",
    },
    {
      name: "REST AP1",
      banner: img9,
      img: [img9],
      tech: "Express JS,MongoDB",
      desc: "REST API Using Express JS,MongoDB",
      link: "https://github.com/Sahil3554/rest_api",
    },
  ];
  return (
    <div className="App">
      <Context.Provider value={project_arr}>
        <Router>
          <Header />

          <Switch>
            <Route exact path="/" component={Home}></Route>
            <Route exact path="/project/:id" component={ProjectDetail}></Route>
            <Route path="*" component={Error}></Route>
          </Switch>

          <Footer />
        </Router>
      </Context.Provider>
    </div>
  );
}

export default App;
export { Context };
